import { Injectable } from '@angular/core';
import { isNullOrEmptyArray } from '../../core/functions/common-functions';
import {
  Region,
  RegionConnection,
  RegionSearch,
} from '../../model/locations/region';

@Injectable({
  providedIn: 'root',
})
export class RegionBuilderService {
  constructor() {}

  buildRegion(item: any, areas: any[] | null = null): Region {
    if (!isNullOrEmptyArray(areas)) {
      const areaIds = item.areas ? item.areas.map((f: any) => f.id) : [];
      const ars = areas ? areas.filter((f) => areaIds.includes(f.id)) : [];
      item.areas = ars;
    }

    const region = {
      id: item.id,
      name: item.name,
      contactListId: item.contactListId,
      owner: item.owner,
      ownerId: item.owner ? item.owner.id : '',
      areas:
        item.areas && item.areas.length > 0
          ? item.areas.map((f: any) => ({
              id: f.id,
              name: f.name,
            }))
          : [],
      updater: item.updater,
      deletedAt: item.deletedAt,
      version: item.version,
    };

    return region;
  }

  buildUpdateStatement(regionInput: any): any {
    const retVal: any = {};

    if (regionInput.hasOwnProperty('name')) {
      retVal['name'] = regionInput.name;
    }
    if (regionInput.hasOwnProperty('ownerId')) {
      retVal['ownerId'] = regionInput.ownerId;
    }
    if (regionInput.hasOwnProperty('contactListId')) {
      retVal['contactListId'] = regionInput.contactListId;
    }

    return retVal;
  }

  buildRegionSearch(item: any): RegionSearch {
    return {
      id: item.id,
      name: item.name,
      contactList: item.contactList,
      owner: item.owner,
      areas: item.areas,
    };
  }

  buildRegionConnection(item: any): RegionConnection {
    return {
      items: item.items.map((i: any) => this.buildRegionSearch(i)),
      totalRecords: item.totalRecords,
    };
  }
}
